import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios';
import config from '../../config';
import Footer from '../Footer/FooterWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import './Blog.css';
import { useLanguage } from '../../i18n/LanguageContext';

const BlogList = () => {
  const { t } = useLanguage();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();
  const backend_url = config.backend_url.replace(/\/$/, '');

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${backend_url}/blog/posts`, { withCredentials: true });
        if (response.data.success) {
          setPosts(response.data.posts);
        } else {
          setError('Failed to fetch blog posts');
        }
      } catch (err) {
        console.error('Error fetching blog posts:', err);
        setError('Failed to fetch blog posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [backend_url]);

  const handlePostClick = (postId) => {
    history.push(`/blog/${postId}`);
  };

  // Function to create excerpt from HTML content
  const createExcerpt = (content, maxLength = 150) => {
    // Remove HTML tags
    const text = content.replace(/<\/?[^>]+(>|$)/g, "");
    // Truncate and add ellipsis if needed
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  // Format date to readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('sv-SE', options);
  };

  if (loading) {
    return (
      <div className="blog-container">
        <div className="blog-header">
          <h1><FontAwesomeIcon icon={faNewspaper} className="blog-icon" /> {t('Blogg')}</h1>
          <p>{t('Laddar inlägg...')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-container">
        <div className="blog-header">
          <h1><FontAwesomeIcon icon={faNewspaper} className="blog-icon" /> {t('Blogg')}</h1>
          <p className="error-message">{t(error)}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="blog-container">
        <div className="blog-header">
          <h1><FontAwesomeIcon icon={faNewspaper} className="blog-icon" /> {t('Blogg')}</h1>
          <p>{t('Senaste nyheterna och uppdateringarna från Bodex')}</p>
        </div>

        {posts.length === 0 ? (
          <p className="no-posts-message">{t('Inga inlägg än. Kom tillbaka snart!')}</p>
        ) : (
          <div className="blog-posts">
            {posts.map((post) => (
              <div 
                key={post.id} 
                className="blog-post-card" 
                onClick={() => handlePostClick(post.id)}
              >
                {post.image_filename && (
                  <img 
                    src={`${backend_url}/static/blog_images/${post.image_filename}`} 
                    alt={post.title} 
                    className="blog-post-image" 
                  />
                )}
                <div className="blog-post-content">
                  <h2 className="blog-post-title">{post.title}</h2>
                  <div className="blog-post-metadata">
                    <span className="blog-post-author">{t('Av:')} {post.author}</span>
                    <span className="blog-post-date">{formatDate(post.created_at)}</span>
                  </div>
                  <p className="blog-post-excerpt">{createExcerpt(post.content)}</p>
                  <button className="cta-button">{t('Läs mer')}</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default BlogList;
